import * as THREE from "three";

import electronShader_frag from "./electrons_frag.glsl";
import electronShader_vert from "./electrons_vert.glsl";
import { useMemo } from "react";
import { useFrame } from "@react-three/fiber";

let sineTime = 0;
let cosTime = 0;

const CapacitorAnimation = ({ nodes }) => {
  const [material0, material1] = useMemo(() => {
    const material = new THREE.ShaderMaterial({
      fragmentShader: electronShader_frag,
      vertexShader: electronShader_vert,
      // vertexColors: true,
      transparent: true,
      depthWrite: false,
      depthTest: false,
      side: THREE.DoubleSide,
      // blending: AdditiveBlending,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 0.2,
        },
        uBaseColor: {
          value: new THREE.Color("#e5ff00"),
        },
        uBaseColorPower: {
          value: 1,
        },
        uSize: {
          value: 0.02,
        },
        uStep: {
          value: 0.8,
        },
        uStepRange: {
          value: 0.2,
        },
        uDirection: {
          value: 1,
        },
        uOpacity: {
          value: 0.185,
        },
        uCarrierPosition: {
          value: nodes.marker_0.position,
        },
        uDistortion: {
          value: 2,
        },
      },
    });

    const material2 = material.clone();
    material2.uniforms.uDirection.value = 1;
    material2.uniforms.uDistortion.value = 0;

    return [material, material2];
  }, []);

  const animationFrequence = 0.8;

  useFrame(({ clock }) => {
    material0.uniforms.uTime.value = clock.elapsedTime;
    material1.uniforms.uTime.value = clock.elapsedTime;
    sineTime = Math.sin(clock.elapsedTime * animationFrequence) * 0.5 + 0.4;
    cosTime = Math.sin(clock.elapsedTime * animationFrequence + Math.PI) * 0.5 + 0.4;

    sineTime = Math.max(sineTime, 0);
    cosTime = Math.max(cosTime, 0);
    sineTime = Math.min(sineTime * 1, 1.0);
    cosTime = Math.min(cosTime * 1, 1.0);

    material0.uniforms.uOpacity.value = sineTime * 0.185;
    material1.uniforms.uOpacity.value = cosTime * 0.185;
  });

  return (
    <group rotation={[0, THREE.MathUtils.degToRad(-90), 0]}>
      <mesh geometry={nodes.ME_cable_in.geometry} material={material0}></mesh>
      <mesh geometry={nodes.ME_cable_out.geometry} material={material1} visible={true}></mesh>
      <mesh geometry={nodes.ME_cable_bottom_in.geometry} material={material0}></mesh>
      <mesh geometry={nodes.ME_cable_bottom_out.geometry} material={material1} visible={true}></mesh>
    </group>
  );
};

export default CapacitorAnimation;
